import { studentOrParentGetLatestActivity } from '@school_ify/schoolify-repository/src/student_parent/repositories/activityRepository';
import { StudentOrParentActivityLatestQuery } from '@school_ify/schoolify-repository/src/student_parent/types';

class LatestActivityService {
  public async getStudentLatestActivity(): Promise<StudentOrParentActivityLatestQuery> {
    try {
      // @ts-ignore
      return await studentOrParentGetLatestActivity();
    } catch (err) {
      throw new Error(`Latest activity overview error: ${err}`);
    }
  }
}

export default new LatestActivityService();
